import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import IntHero from './components/IntHero';
import IntPlatforms from './components/IntPlatforms';
import IntCTA from './components/IntCTA';

export default function Integrations() {
  return (
    <main>
      <Navbar />
      <IntHero />
      <IntPlatforms />
      <IntCTA />
      <Footer />
    </main>
  );
}